// export const apiUrl = "http://localhost/projet_cartel/api/";
// export const apiUrl = "https://api.planning-cartelconcerts.com/";
export const apiUrl = "https://api.booking-cartel.fr/";
// export const apiUrl = "https://apicartel.kindr.fr/";
